import { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { LeaseStatus, LEASE_STATUS_MESSAGES_STRINGS } from '@arrived/models';

import { LeaseStatusMessage } from '../LeaseStatusMessage';
import { PropertyDetailsTooltip } from '../PropertyDetailsTooltip';

import { PropertyDetailsQuickLookItem } from '../quickLook';

interface RentalStatusQuickLookItemProps {
  leaseStatus: LeaseStatus;
}

export const RentalStatusQuickLookItem = ({ leaseStatus }: RentalStatusQuickLookItemProps) => {
  const intl = useIntl();
  const leaseStatusTooltip = useMemo(
    () => leaseStatus && LEASE_STATUS_MESSAGES_STRINGS[leaseStatus].tooltip,
    [leaseStatus, intl]
  );
  return (
    <PropertyDetailsQuickLookItem
      label={
        leaseStatusTooltip ? (
          <PropertyDetailsTooltip
            title={<FormattedMessage id={leaseStatusTooltip.id} defaultMessage={leaseStatusTooltip.text} />}
          >
            <FormattedMessage id="rent-info-rental-status-title" defaultMessage="Rental Status" />
          </PropertyDetailsTooltip>
        ) : (
          <FormattedMessage id="rent-info-rental-status-title" defaultMessage="Rental Status" />
        )
      }
      value={leaseStatus && <LeaseStatusMessage leaseStatus={leaseStatus} />}
    />
  );
};
